import { defineComponent as _defineComponent } from 'vue'
import {
  useManagedListFilter,
  defineUseManagedListFilterProps,
  UseManagedListFilterEmits,
} from 'ah-common-lib/src/listing';
import SearchInput from 'ah-common-lib/src/common/components/SearchInput.vue';
import MaterialIcon from 'bd-common/src/components/common/MaterialIcon.vue';
import { BFormInput } from 'bootstrap-vue';

interface SearchFilters {
  query?: string;
  queryBy?: string[];
}

interface SearchFilterEmit extends UseManagedListFilterEmits<SearchFilters> {}


export default /*#__PURE__*/_defineComponent({
  __name: 'SearchFilter',
  props: {
  ...defineUseManagedListFilterProps<SearchFilters>(),
  queryBy: {
    type: [Array<string>, String],
    required: true,
  },
  placeholder: {
    type: String,
    default: 'Search',
  },
},
  setup(__props, { emit }: { emit: ({}), expose: any, slots: any, attrs: any }) {

const props = __props;





const managedListingFilter = useManagedListFilter<SearchFilters>({
  emit,
  props,
  filterKeys: [
    {
      key: 'query',
      getter: (filters) => filters.value.query || undefined,
      setter: (value, filters) => (filters.value.query = value),
    },
    {
      key: 'queryBy',
      getter: (filters) => (filters.value.query ? props.queryBy : undefined),
      setter: () => {
        // queryBy is ignored, as it's provided by props
      },
    },
  ],
  sortAndPageKeys: [],
});

return { __sfc: true,props, emit, managedListingFilter, SearchInput, MaterialIcon, BFormInput }
}

})